import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import ProductsTab from './products/ProductsTab';
import OrdersTab from './order/OrdersTab';
import ManagersTab from './ManagersTab';
import StoresTab from './StoresTab';
import ThemesTab from './ThemesTab';
import SettingsTab from './SettingsTab';
import BranchesTab from './branch/BranchesTab';

export default function AdminDashboard() {
  const { user, logout,  } = useAuth();
  const [activeTab, setActiveTab] = useState('products');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!user || (user.role !== 'branch_owner' && user.role !== 'super_admin')) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 text-center">
        <div className="bg-white p-6 rounded-lg shadow-md max-w-md w-full">
          <h1 className="text-2xl font-bold mb-2 text-red-600">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to view this page.
          </p>
          <a href="/" className="text-primary hover:underline font-medium">
            Return to homepage
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <AdminHeader
        onLogout={logout}
        onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      {/* Grid Layout */}
      <div className="grid grid-cols-1 md:grid-cols-[16rem_1fr] pt-16 min-h-[calc(100vh-4rem)]">
        {/* Sidebar - Grid Column 1 */}
        <div
          className={`${
            sidebarOpen ? 'block' : 'hidden'
          } md:block fixed z-40 inset-0 md:relative md:z-auto bg-white md:bg-transparent`}
        >
          <div className="h-full md:h-auto md:shadow-none shadow-lg">
            <AdminSidebar
              user={user}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              closeSidebar={() => setSidebarOpen(false)}
            />
          </div>

          {/* Overlay for mobile */}
          <div
            className="md:hidden fixed inset-1 bg-black bg-opacity-50 max-sm:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        </div>

        {/* Main Content - Grid Column 2 */}
        <main className="p-4">
          <div className="bg-white rounded-xl shadow-md p-6 min-h-[calc(100vh-8rem)]">
            {activeTab === 'products' && <ProductsTab />}
            {activeTab === 'orders' && <OrdersTab />}
            {activeTab === 'branches' && <BranchesTab />}
            {activeTab === 'managers' && <ManagersTab />}
            {activeTab === 'stores' && <StoresTab />}
            {activeTab === 'themes' && <ThemesTab />}
            {activeTab === 'settings' && <SettingsTab />}
          </div>
        </main>
      </div>
    </div>
  );
}
